import React, { useEffect, useState } from "react";
import { Role } from "@/model";
import { useRole } from "@/query/role";
import { useScenarioId } from "@/hook";
import { DropdownGroup, DropdownButton, DropdownItem, DropdownItems } from "@/component/input";


interface RoleDropDownProps {
    role?: Role;
    "aria-label"?: string;
    onChange: (role: Role) => void;
}

const RoleDropDown: React.FC<RoleDropDownProps> = (props) => {
    const { role, "aria-label": ariaLabel, onChange } = props;

    const scenarioId = useScenarioId();

    const [selectedRole, setSelectedRole] = useState<Role | undefined>(role);

    const { data: roles, isLoading } = useRole(scenarioId);

    const onSelect = (role: Role) => {
        setSelectedRole(role);
        onChange(role);
    };

    useEffect(() => {
        if (role) {
            setSelectedRole(role);
        } else if (roles?.length) {
            setSelectedRole(roles[0]);
            onChange(roles[0]);
        }
    }, [role, roles, onChange]);

    if (isLoading) {
        return null;
    }
    return (
        <DropdownGroup aria-label={ariaLabel}>
            <DropdownButton>
                {selectedRole?.description}
            </DropdownButton>
            <DropdownItems>
                {roles && roles.map((role, index) => (
                    <DropdownItem key={role.id}
                                  isOdd={index % 2 === 1}
                                  onClick={() => onSelect(role)}
                    >
                        {role.description}
                    </DropdownItem>
                ))}
            </DropdownItems>
        </DropdownGroup>
    );
};

export default RoleDropDown;
